import { gql } from "@apollo/client";

export default {
  user: {
    name: "user",
    serviceName: "auth",
    query: gql`
      query {
        user {
          id
          token
          roles
          lastname
          firstname
          cellphone
          is_active
          media {
            full_url
            collection_name
          }
          wallet {
            balance
          }
          all_roles {
            status
            is_demo
            labs {
              id
              title
            }
            units {
              id
              title
            }
            role {
              id
              name
              title
            }
          }
        }
      }
    `,
  },
};
